<template>
    <div class="d-flex align-items-center justify-content-center" style="height: 400px">
        <div class="unex-login-required"></div>
    </div>
</template>

<script>
import App from './../application.js'

export default {
    components: {

    },

    data: function () {
        return {
            App: App,
            Unex: window.Unex
        };
    },
    mounted: function () {
        var self = this
        window.Unex.Authentication.bindDOMElements()

        window.Unex.Authentication.on('login', async function () {
            await App.init()
            self.checkIfAuthenticated()
        });

        this.checkIfAuthenticated()
    },
    methods: {
        checkIfAuthenticated: function () {
            if (App.initialized) {
                if (App.auth_returl_url) {
                    this.$router.push(App.auth_returl_url)
                    App.auth_returl_url = null
                } else {
                    this.$router.push('/')
                }
            }
        }
    }
}
</script>

<style></style>